const copyKeyText = () => {
	const keyBox = document.querySelectorAll('.downloads-info--key');

	if (!keyBox.length) {
		return;
	}

	if (!navigator.clipboard) {
		// Clipboard API not available
		document.body.classList.add('no-clipboard');
		return;
	}

	keyBox.forEach((box) => {
		const copyBtn = box.querySelector('.downloads-key-copy');
		copyBtn.addEventListener('click', async (event) => {
			const currentItem = event.target.parentElement;
			const keyText = currentItem.querySelector('.downloads-key');
			const btnText = copyBtn.innerText;

			try {
				await navigator.clipboard.writeText(keyText.innerText);
				currentItem.classList.add('copied');
				event.target.textContent = 'Copied to clipboard';
				setTimeout(() => {
					currentItem.classList.remove('copied');
					event.target.textContent = btnText;
				}, 2000);
			} catch (err) {
				console.error('Failed to copy!', err);
			}
		})
	})
};

export default copyKeyText;